import { AsyncPipe, NgIf } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { delay, Observable } from "rxjs";

import { Actions, Store } from "@ngxs/store";

import { PrimeNGConfig } from "primeng/api";

import { SubscriberClass } from "@core/classes/subscriber.class";
import { HeaderComponent } from "@core/components/header/header.component";
import { MenuComponent } from "@core/components/menu/menu.component";
import { NotificationBannersComponent } from "@core/components/notification-banner/notification-banners.component";
import { ProgressbarComponent } from "@core/components/progressbar/progressbar.component";
import { PRIME_CALENDAR_CONFIG } from "@core/constants/core.constants";
import { hasActionsRunning } from "@core/helpers/handlers.helper";
import { Nulled } from "@core/interfaces/core.interface";
import { ICurrentUser } from "@core/interfaces/current-user.interface";
import { GlobalActions } from "@core/store/core.actions";
import { CoreStateSelector } from "@core/store/core.selectors";

@Component({
    standalone: true,
    selector: "ruts-site-layout",
    templateUrl: "./site-layout.component.html",
    styleUrls: ["./site-layout.component.scss"],
    imports: [
        NgIf,
        AsyncPipe,
        RouterOutlet,

        // standalone components
        HeaderComponent,
        MenuComponent,
        NotificationBannersComponent,
        ProgressbarComponent,
    ],
})
export class SiteLayoutComponent extends SubscriberClass {
    readonly #primeConfig: PrimeNGConfig = inject(PrimeNGConfig);
    readonly #actions$: Actions = inject(Actions);
    readonly #store: Store = inject(Store);

    readonly currentUser$: Observable<Nulled<ICurrentUser>> = this.#store.select(CoreStateSelector.getUser);

    headerIsLoading$: Observable<boolean>;
    contentUpdating$: Observable<boolean>;

    constructor() {
        super();
        this.#primeConfig.setTranslation(PRIME_CALENDAR_CONFIG);
    }

    ngOnInit(): void {
        this.headerIsLoading$ = hasActionsRunning(this.#actions$, [GlobalActions.AppInit]);
        this.contentUpdating$ = hasActionsRunning(this.#actions$, [
            GlobalActions.SetActivePeriod,
        ]).pipe(delay(500));

        this.addSub([
            this.contentUpdating$.subscribe(res =>
                console.info("Content layout update " + (res ? "started" : "finished"))
            ),
        ]);
    }
}
